import {
  AspectRatio,
  Badge,
  Body,
  Box,
  Heading,
  Image,
  Link,
} from '@hover/blueprint';
import React, { FC } from 'react';
import BLOG_CATEGORIES from '../../../constants/blog-categories';
import { ICBlogPost } from '../../../interfaces/ICBlogPost';
import { dateToFormat } from '../../../utils';

interface Props {
  post: ICBlogPost;
}

const BlogCard: FC<Props> = ({ post }) => {
  const postCategoryData = BLOG_CATEGORIES.find(
    item => item.value === post.categories[0],
  );
  return (
    <Box flexDirection="column" key={post.title}>
      <Link href={`${process.env.GATSBY_V2_PREFIX}/blog/${post.slug}`}>
        <AspectRatio ratio={758 / 420}>
          <Image
            src={post.heroImage.url}
            alt={post.description}
            objectFit="cover"
          />
        </AspectRatio>
      </Link>
      <Box justifyContent="space-between" w="100%" py={500}>
        <Box alignItems="center">
          {postCategoryData ? (
            <Badge
              colorScheme={postCategoryData.color}
              variant="brand"
              textTransform="uppercase"
            >
              {postCategoryData.value}
            </Badge>
          ) : null}
        </Box>
      </Box>
      <Heading
        color="neutral.700"
        size={300}
        pb={400}
        _hover={{ textDecoration: 'none' }}
        marginBottom={0}
      >
        {post.title}
      </Heading>
      <Body color="neutral.700" size={300} marginTop="auto" fontWeight={300}>
        {dateToFormat(post.publishDate)}
      </Body>
    </Box>
  );
};

export default BlogCard;
